"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-0e4b4168"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = ["id"];
const _hoisted_2 = {
    key: 0,
    class: "accordion-header p-0"
};
const _hoisted_3 = ["for"];
const _hoisted_4 = ["href"];
const _hoisted_5 = { class: "branch-count" };
const vue_3 = require("vue");
const AreaSelectorMenuBranch_vue_1 = __importDefault(require("./AreaSelectorMenuBranch.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'AreaSelectorMenu',
    props: {
        areaId: {
            type: Number,
            required: true,
        },
        depth: {
            type: Number,
            required: true,
        },
        isLast: {
            type: Boolean,
            default: false,
        },
        employmentMap: {
            type: Object,
            required: true,
        },
        areaMap: {
            type: Object,
            required: true,
        },
        searchInput: {
            type: String,
            default: "",
        },
    },
    setup(__props) {
        const props = __props;
        const isAccordionOpen = (0, vue_3.ref)(false);
        const { areaMatchesSearch, branchMatchesSearch, areaUrl } = (0, vue_3.inject)('branchSelectorMenu', {
            areaMatchesSearch: (id) => false,
            branchMatchesSearch: (id) => false,
            areaUrl: (id) => '#',
        });
        // area or subarea
        const area = (0, vue_3.computed)(() => {
            return props.areaMap?.get(props.areaId);
        });
        const hasChildren = (0, vue_3.computed)(() => {
            if (!area.value) {
                return false;
            }
            return area.value.subareaIds.length > 0 || area.value.branchIds.length > 0;
        });
        const searchMatchesAreaOrChildren = (0, vue_3.computed)(() => {
            return areaMatchesSearch(props.areaId);
        });
        const searchMatchesSelf = (0, vue_3.computed)(() => {
            if (!props.searchInput || !searchMatchesAreaOrChildren.value || !area.value) {
                return false;
            }
            return area.value.name.toLowerCase().includes(props.searchInput);
        });
        const highlightClass = (0, vue_3.computed)(() => {
            return searchMatchesSelf.value ? 'highlight-matched' : '';
        });
        function countBranchesRecursive(areaId) {
            const area = props.areaMap.get(areaId);
            if (!area)
                return 0;
            return area.branchIds.length + area.subareaIds.reduce((sum, id) => sum + countBranchesRecursive(id), 0);
        }
        const numOfChildBranches = (0, vue_3.computed)(() => {
            return area.value ? countBranchesRecursive(area.value.id) : 0;
        });
        const rowClass = (0, vue_3.computed)(() => {
            return {
                'pl-2': props.depth > 0,
                'pb-2': props.depth === 0 && isAccordionOpen.value && hasChildren.value,
            };
        });
        const accordionClass = (0, vue_3.computed)(() => {
            return isAccordionOpen.value ? 'rotated' : '';
        });
        const areaItemClass = props.depth === 0 ? 'pb-2' : '';
        const filteredSubareaIds = (0, vue_3.computed)(() => {
            return area.value?.subareaIds.filter(id => areaMatchesSearch(id)) || [];
        });
        const filteredBranchIds = (0, vue_3.computed)(() => {
            return area.value?.branchIds.filter(id => branchMatchesSearch(id)) || [];
        });
        function depthBarStyle(depth) {
            return {
                marginLeft: depth > 1 ? "11px" : "3px",
                height: !props.isLast || (isAccordionOpen.value && hasChildren.value) ? '34px' : '24px',
            };
        }
        (0, vue_3.watch)(() => props.searchInput, (searchVal) => {
            // Open accordion if this area or its children matches search
            isAccordionOpen.value = searchVal.trim() !== "" && searchMatchesAreaOrChildren.value;
        });
        return (_ctx, _cache) => {
            const _component_AreaSelectorMenu = (0, vue_2.resolveComponent)("AreaSelectorMenu", true);
            return (0, vue_2.withDirectives)(((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                class: (0, vue_2.normalizeClass)(["accordion flex-column relative mt-0", (0, vue_2.unref)(areaItemClass)])
            }, [
                (0, vue_2.createElementVNode)("div", {
                    class: (0, vue_2.normalizeClass)(["d-flex", highlightClass.value])
                }, [
                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(__props.depth, (d) => {
                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                            key: d,
                            class: "depth-bar",
                            style: (0, vue_2.normalizeStyle)(depthBarStyle(d))
                        }, null, 4 /* STYLE */));
                    }), 128 /* KEYED_FRAGMENT */)),
                    (area.value)
                        ? (0, vue_2.withDirectives)(((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("input", {
                            key: 0,
                            type: "checkbox",
                            id: `area-dropdown-${area.value.id}`,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((isAccordionOpen).value = $event)),
                            hidden: ""
                        }, null, 8 /* PROPS */, _hoisted_1)), [
                            [vue_2.vModelCheckbox, isAccordionOpen.value]
                        ])
                        : (0, vue_2.createCommentVNode)("v-if", true),
                    (0, vue_2.createElementVNode)("div", {
                        class: (0, vue_2.normalizeClass)(["menu-area-row", rowClass.value])
                    }, [
                        (area.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, [
                                (0, vue_2.createElementVNode)("label", {
                                    class: "c-hand p-0 accordion-toggle",
                                    for: 'area-dropdown-' + area.value.id
                                }, [
                                    (0, vue_2.createElementVNode)("i", {
                                        class: (0, vue_2.normalizeClass)(["icon icon-arrow-right", accordionClass.value])
                                    }, null, 2 /* CLASS */)
                                ], 8 /* PROPS */, _hoisted_3),
                                (0, vue_2.createElementVNode)("a", {
                                    class: "menu-area-name text-ellipsis area-name-link",
                                    href: (0, vue_2.unref)(areaUrl)(area.value.id)
                                }, (0, vue_2.toDisplayString)(area.value.name), 9 /* TEXT, PROPS */, _hoisted_4),
                                (0, vue_2.createElementVNode)("span", _hoisted_5, " (" + (0, vue_2.toDisplayString)(numOfChildBranches.value) + ") ", 1 /* TEXT */)
                            ]))
                            : (0, vue_2.createCommentVNode)("v-if", true)
                    ], 2 /* CLASS */)
                ], 2 /* CLASS */),
                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("div", null, [
                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(filteredSubareaIds.value, (id, index) => {
                        return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_AreaSelectorMenu, {
                            key: 'subarea-' + id,
                            "area-id": id,
                            depth: __props.depth + 1,
                            "is-last": !filteredBranchIds.value.length && index === filteredSubareaIds.value.length - 1,
                            "search-input": String(__props.searchInput),
                            "employment-map": __props.employmentMap,
                            "area-map": __props.areaMap
                        }, null, 8 /* PROPS */, ["area-id", "depth", "is-last", "search-input", "employment-map", "area-map"]));
                    }), 128 /* KEYED_FRAGMENT */)),
                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(filteredBranchIds.value, (id, index) => {
                        return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(AreaSelectorMenuBranch_vue_1.default, {
                            key: 'branch-' + id,
                            "branch-id": id,
                            depth: __props.depth + 1,
                            "is-last-branch": index === filteredBranchIds.value.length - 1,
                            "is-last-area": __props.isLast,
                            "search-input": String(__props.searchInput),
                            "employment-map": __props.employmentMap
                        }, null, 8 /* PROPS */, ["branch-id", "depth", "is-last-branch", "is-last-area", "search-input", "employment-map"]));
                    }), 128 /* KEYED_FRAGMENT */))
                ], 512 /* NEED_PATCH */), [
                    [vue_2.vShow, area.value && isAccordionOpen.value && hasChildren.value]
                ])
            ], 2 /* CLASS */)), [
                [vue_2.vShow, searchMatchesAreaOrChildren.value]
            ]);
        };
    }
});
